import { VenuePinType } from "common/types";

// Which state each colour means is decided by getPinIcon in common/utils/maps;
// this only says how that state looks.
export const PIN_COLORS_LIGHT: Record<VenuePinType, string> = {
  [VenuePinType.Green]: "#1E6036",
  [VenuePinType.Black]: "#05000b",
  [VenuePinType.Blue]: "#2B26A3",
  [VenuePinType.Purple]: "#8E82E8",
  [VenuePinType.Orange]: "#C65200",
  [VenuePinType.Grey]: "#9AA0A6",
};

// Lifted to read against dark tiles. States left out keep their light colour.
export const PIN_COLORS_DARK: Partial<Record<VenuePinType, string>> = {
  [VenuePinType.Green]: "#2E8A52",
  [VenuePinType.Blue]: "#352FB8",
  [VenuePinType.Purple]: "#BDB7F3",
  [VenuePinType.Orange]: "#F97413",
};

export function getPinColor(
  pinType: VenuePinType | undefined,
  isDark: boolean,
): string {
  const type = pinType ?? VenuePinType.Grey;

  return (isDark ? PIN_COLORS_DARK[type] : undefined) ?? PIN_COLORS_LIGHT[type];
}

/** Mapper view colours every state; user view only tells data from no data. */
export function getVenuePinColor(
  pinType: VenuePinType | undefined,
  isMapperView: boolean,
  isDark: boolean,
): string {
  if (isMapperView) {
    return getPinColor(pinType, isDark);
  }

  return getPinColor(
    pinType === VenuePinType.Grey ? VenuePinType.Grey : VenuePinType.Orange,
    isDark,
  );
}
